module.exports = __webpack_public_path__ + "static/media/img_fenlei01.c35defb0.png";